import { useTranslation } from "react-i18next";
import { useLegalDocument } from "../../hooks/useLegalDocument";
import type { LegalDocKey } from "../../constants/legal";
import { ScrollToTop } from "../ScrollToTop";
import { ScrollFadeIndicator } from "../ScrollFadeIndicator";

interface LegalContentProps {
  doc: LegalDocKey;
  /** Overlay scroll thumb color. Bind to a theme slot; defaults to the inherited text color. */
  thumbColor?: string;
}

export const LegalContent: React.FC<LegalContentProps> = ({
  doc,
  thumbColor = "currentColor",
}) => {
  const { t } = useTranslation();
  const { html, isLoading, error, retry } = useLegalDocument(doc);

  if (isLoading) {
    return (
      <div className="legal-loading foreground">
        <div className="legal-skeleton" />
        <div className="legal-skeleton" />
        <div className="legal-skeleton" />
        <div className="legal-skeleton" />
        <span className="muted-foreground">{t("legal.loading")}</span>
      </div>
    );
  }

  if (error || !html) {
    return (
      <div className="legal-error foreground">
        <span>{t("legal.error")}</span>
        <button type="button" className="legal-retry-btn" onClick={retry}>
          {t("legal.retry")}
        </button>
      </div>
    );
  }

  return (
    <>
      <div className="legal-content foreground">
        <ScrollFadeIndicator color={thumbColor} />
        <div dangerouslySetInnerHTML={{ __html: html }} />
      </div>
      <ScrollToTop />
    </>
  );
};
